import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enLocales from "../locales/en/translation.json";
import deLocales from "../locales/de/translation.json";
import dkLocales from "../locales/dk/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enLocales,
      },
      de: {
        translation: deLocales,
      },
      dk: {
        translation: dkLocales,
      },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });
